import { cva } from '@mentimeter/ragnar-tailwind-config';

export const iconButtonVariants = cva([], {
  variants: {
    variant: {
      primary: [
        'bg-button-bg-primary',
        'text-on-primary',
        '[&:enabled]:data-[has-status="false"]:focus-visible:bg-button-bg-primary-hover',
        '[&:enabled]:data-[has-status="false"]:hover:bg-button-bg-primary-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:active:bg-button-bg-primary-active',
        '[&:enabled]:data-[has-status="false"]:hover:active:bg-button-bg-primary-active',
      ],
      primaryReverse: [
        'bg-button-bg-primary-reverse',
        'text-text',
        '[&:enabled]:data-[has-status="false"]:hover:active:bg-button-bg-primary-reverse-active',
        '[&:enabled]:data-[has-status="false"]:focus-visible:bg-button-bg-primary-reverse-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:active:bg-button-bg-primary-reverse-active',
        '[&:enabled]:data-[has-status="false"]:hover:bg-button-bg-primary-reverse-hover',
      ],
      secondary: [
        'text-text',
        '[&:enabled]:data-[has-status="false"]:hover:active:bg-button-bg-secondary-active',
        '[&:enabled]:data-[has-status="false"]:focus-visible:bg-button-bg-secondary-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:active:bg-button-bg-secondary-active',
        '[&:enabled]:data-[has-status="false"]:hover:bg-button-bg-secondary-hover',
      ],
      tertiary: [
        'bg-button-bg-tertiary',
        'text-text',
        '[&:enabled]:data-[has-status="false"]:hover:active:bg-button-bg-tertiary-active',
        '[&:enabled]:data-[has-status="false"]:focus-visible:bg-button-bg-tertiary-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:active:bg-button-bg-tertiary-active',
        '[&:enabled]:data-[has-status="false"]:hover:bg-button-bg-tertiary-hover',
      ],
      outline: [
        'bg-bg',
        'text-text',
        '[&:enabled]:shadow-[inset_0_0_0_2px_theme(colors.text.DEFAULT)]',
        'data-[has-status="true"]:shadow-[inset_0_0_0_2px_theme(colors.text.DEFAULT)]',
        '[&:enabled]:data-[has-status="false"]:hover:active:bg-button-bg-outline-active',
        '[&:enabled]:data-[has-status="false"]:focus-visible:bg-button-bg-outline-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:active:bg-button-bg-outline-active',
        '[&:enabled]:data-[has-status="false"]:hover:bg-button-bg-outline-hover',
      ],
      negativeWeak: [
        'bg-button-bg-negative-weak',
        'text-on-negative-weakest',
        '[&:enabled]:data-[has-status="false"]:hover:bg-button-bg-negative-weak-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:bg-button-bg-negative-weak-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:active:bg-button-bg-negative-weak-active',
        '[&:enabled]:data-[has-status="false"]:hover:active:bg-button-bg-negative-weak-active',
      ],
      brand: [
        'bg-button-bg-brand',
        'text-on-brand',
        '[&:enabled]:data-[has-status="false"]:hover:bg-button-bg-brand-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:bg-button-bg-brand-hover',
        '[&:enabled]:data-[has-status="false"]:focus-visible:active:bg-button-bg-brand-active',
        '[&:enabled]:data-[has-status="false"]:hover:active:bg-button-bg-brand-active',
      ],
    },
    borderRadius: {
      medium: ['rounded-lg'],
      full: ['rounded-full'],
    },
    size: {
      large: ['p-[calc(--spacing(3)+2px)]'],
      default: ['p-3'],
      compact: ['p-2'],
    },
    status: {
      loading: [],
      success: ['bg-button-bg-positive', 'text-on-positive'],
      error: ['bg-button-bg-negative', 'text-on-negative'],
    },
  },
  defaultVariants: {
    borderRadius: 'medium',
    size: 'default',
    variant: 'primary',
    status: null,
  },
});
